import React from "react";
import { XIcon, CheckIcon } from "lucide-react";
import { SectionHeading } from "../SectionHeading";
import { CtaButton } from "../CtaButton";
import { before, after } from "../../data/content";
export function BeforeAfter() {
  return <section className="bg-ink-900 px-5 py-16 sm:py-20" data-id="element-84" data-mp="26mmc2mgrh5ks">
      <div className="mx-auto max-w-6xl" data-id="element-85" data-mp="22lasoyohdgl1">
        <SectionHeading kicker="Before vs. After Occlusion Blueprint" title="From Scattered Information to a More Organized Clinical Workflow" data-id="element-86" data-mp="22mlz769b92fu" />

        <div className="grid gap-5 md:grid-cols-2" data-id="element-87" data-mp="2ud03qbvfp2eu">
          <div className="rounded-3xl border-2 border-red-500/40 bg-red-950/40 p-6 sm:p-8" data-id="element-88" data-mp="2qabx8au707l1">
            <div className="mb-6 flex items-center gap-3" data-id="element-89" data-mp="2qc6jptl447r8">
              <span className="flex h-11 w-11 items-center justify-center rounded-full bg-red-500 text-white" data-id="element-90" data-mp="2lah5y66i9fzg">
                <XIcon className="h-6 w-6" strokeWidth={3} aria-hidden="true" data-id="element-91" data-mp="1ewhvkyw4h2ou" />
              </span>
              <h3 className="font-display text-2xl font-black uppercase text-red-300" data-id="element-92" data-mp="19ushtbhimax2">Before</h3>
            </div>
            <ul className="space-y-4" data-id="element-93" data-mp="1739leny8szzk">
              {before.map(t => <li key={t} className="flex gap-3 text-[15px] leading-relaxed text-slate-200 sm:text-base" data-id="element-94" data-mp="1c3xedf617qwf">
                  <XIcon className="mt-1 h-4 w-4 shrink-0 text-red-400" strokeWidth={3} aria-hidden="true" data-id="element-95" data-mp="y4ej3mybka1j" />
                  {t}
                </li>)}
            </ul>
          </div>

          <div className="rounded-3xl border-2 border-cta/50 bg-emerald-950/40 p-6 sm:p-8" data-id="element-96" data-mp="odjw2gd916f1">
            <div className="mb-6 flex items-center gap-3" data-id="element-97" data-mp="t760jl99e3zr">
              <span className="flex h-11 w-11 items-center justify-center rounded-full bg-cta text-cta-text" data-id="element-98" data-mp="fepzgpzx4g1h">
                <CheckIcon className="h-6 w-6" strokeWidth={3} aria-hidden="true" data-id="element-99" data-mp="jgtf7qtme6sk" />
              </span>
              <h3 className="font-display text-2xl font-black uppercase text-emerald-300" data-id="element-100" data-mp="5h1uz8cifu64">With Occlusion Blueprint™</h3>
            </div>
            <ul className="space-y-4" data-id="element-101" data-mp="ah6b2x9iamvt">
              {after.map(t => <li key={t} className="flex gap-3 text-[15px] leading-relaxed text-white sm:text-base" data-id="element-102" data-mp="2c5u2m62xy8e4">
                  <CheckIcon className="mt-1 h-4 w-4 shrink-0 text-cta" strokeWidth={3} aria-hidden="true" data-id="element-103" data-mp="27bzp5kdxipnh" />
                  {t}
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mx-auto mt-14 max-w-3xl rounded-3xl bg-brand px-6 py-8 text-center sm:px-10" data-id="element-104" data-mp="1yaroivnxxcq8">
          <h3 className="font-display text-2xl font-black text-ink-950 sm:text-3xl" data-id="element-105" data-mp="2v10yd9ul64tt">My Goal Is Simple</h3>
          <p className="mt-3 text-base leading-relaxed text-ink-900 sm:text-lg" data-id="element-106" data-mp="2qzp6exo8p7ig">
            I want to help you spend less time organizing scattered information and more time applying your professional judgment to the case in front of you.
          </p>
          <p className="mt-3 text-sm font-semibold text-ink-900 sm:text-base" data-id="element-107" data-mp="1aobe1mcabxdf">
            Occlusion Blueprint does not replace your clinical judgment. It gives you a structured way to organize the information that supports it.
          </p>
        </div>

        <div className="mt-10" data-id="element-108" data-mp="10jcwvhxadbuu">
          <CtaButton label="I Want a More Structured Approach" data-id="element-109" data-mp="10ik11bzv86rh" />
        </div>
      </div>
    </section>;
}